import { Button, Form, Input, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../LoginEmail/loginEmail.css';

interface LoginForgotPasswordProps {
  onFinish: (data: { email: string }) => void;
}

export const LoginForgotPassword = ({ onFinish }: LoginForgotPasswordProps) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      name='login'
      className='space-y-4 mt-6'
      onFinish={onFinish}
      layout='vertical'
      size='large'
    >
      <div className="space-y-6">
        <Form.Item
          label={<Typography.Text className='text-black font-bold'>Email</Typography.Text>}
          name='email'
          rules={[
            {
              required: true,
              message: 'Please enter your email!',
              type: 'email',
            },
          ]}
        >
          <Input
            placeholder='email@email.com'
            className='input-no-border'
          />
        </Form.Item>

        <div className="text-xs text-gray-500 text-center">We'll send a recovery code to the email provided above.
          Please also check your spam folder.</div>
        <Form.Item>
          <Button type='primary' htmlType='submit' className='w-full'>
            Send
          </Button>
        </Form.Item>
      </div>

      <div className='w-full text-center'>
        <button className='text-sm text-primary hover:underline' type='button' onClick={() => navigate('/login')}>
          Return to login
        </button>
      </div>
    </Form>
  );
};
